import { render, staticRenderFns } from "./ExpansionPanel.vue?vue&type=template&id=1574f27e&scoped=true"
import script from "./ExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./ExpansionPanel.vue?vue&type=script&lang=ts"
import style0 from "./ExpansionPanel.vue?vue&type=style&index=0&id=1574f27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1574f27e",
  null
  
)

export default component.exports